import React from "react";
import style from "./UserResume.module.scss";
import { useSelector } from "react-redux";
import { capitalizeFirstChar } from "utils/utils";

const UserResume = ({ data, showLine = false }) => {
  const { userProfile } = useSelector((state) => {
    return state.userProfile;
  });

  const currentUserId = userProfile?.userAliasId;

  return (
    <div className={style.groupContainer}>
      <div className={style.personalDetails}>
        <p>Personal Details</p>
        <div className={style.contentholder}>
          {/*Show Mobile number on resume Page and show it on profile page on user's self profile only */}
          {showLine ? (
            <>
              {currentUserId === data?.userAliasId && (
                <div className={style.dataItem}>
                  <p>Mobile Number</p>
                  <p>{data?.mobileNo}</p>
                </div>
              )}
            </>
          ) : (
            <div className={style.dataItem}>
              <p>Mobile Number</p>
              <p>{data?.mobileNo}</p>
            </div>
          )}

          <div className={style.dataItem}>
            <p>Gender</p>
            <p>{capitalizeFirstChar(data?.gender)}</p>
          </div>
          <div className={style.dataItem}>
            <p>State</p>
            <p>{data?.state?.name}</p>
          </div>
          <div className={style.dataItem}>
            <p>City</p>
            <p>{data?.city?.name}</p>
          </div>

          <div className={style.dataItem}>
            <p>Education</p>
            <p>
              {data?.educations?.length > 0
                ? data?.educations?.map((edu) => edu?.degree).join(", ")
                : "N/A"}
            </p>
          </div>

          <div className={style.dataItem}>
            <p>Work Title</p>
            <p>
              {data?.industry?.length > 0
                ? data?.industry?.map((ind) => ind).join(", ")
                : "N/A"}
            </p>
          </div>
        </div>
      </div>
      {showLine &&
        data?.workExperiences?.length > 0 &&
        data?.workExperiences?.[0].yearOfExperience ? (
        <hr />
      ) : (
        ""
      )}
      {/* {showLine && data?.workExperiences?.length > 0 && data?.workExperiences?.[0].yearOfExperience && <hr />}  */}

      {data?.workExperiences?.length > 0 && (
        <div className={style.personalDetails}>
          {data?.workExperiences?.[0].yearOfExperience >= 0 &&
            data?.workExperiences?.[0].yearOfExperience !== null ? (
            <p>Work Experience</p>
          ) : (
            ""
          )}
          {data?.workExperiences?.map((wk, index) => {
            return (
              <>
                <div className={style.contentholder}>
                  {wk?.yearOfExperience >= 0 &&
                    wk?.yearOfExperience !== null ? (
                    <div className={style.dataItem}>
                      <p>Years of experience</p>
                      <p>{wk?.yearOfExperience}</p>
                    </div>
                  ) : (
                    ""
                  )}
                  {wk?.designation?.length > 0 ? (
                    <div className={style.longDataItem}>
                      <p>Description</p>
                      <p>{wk?.designation}</p>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                {data?.workExperiences?.length - 1 !== index ? (
                  <hr className={style.horizontalBar} />
                ) : (
                  ""
                )}
              </>
            );
          })}

          {showLine &&
            data?.workExperiences?.length > 0 &&
            data?.workExperiences?.[0].yearOfExperience ? (
            <hr className={style.horizontalBar} />
          ) : (
            ""
          )}
        </div>
      )}

      <div className={style.chipContainer}>
        {data?.skills?.length > 0 ? <p>Skills</p> : ""}
        <div className={style.chipArray}>
          {data?.skills?.map((skill, index) => {
            return (
              <div key={index} className={style.chipItem}>
                {skill}
              </div>
            );
          })}
        </div>
      </div>

      {/* <hr /> */}

      {data?.categories?.length > 0 ? (
        <div className={style.chipContainer}>
          <p>Niche</p>
          <div className={style.chipArray}>
            {data?.categories?.map((category, index) => {
              return (
                <div key={index} className={style.chipItem}>
                  {category.name}
                </div>
              );
            })}
            {/* <div className={style.chipItem}>{data?.category}</div> */}
          </div>
        </div>
      ) : (
        ""
      )}

      {data?.otherActivities && data?.otherActivities.length > 0 ? (
        <>
          <div className={style.personalDetails}>
            <div className={style.contentholder}>
              <div className={style.extraBold}>
                <p>Other Achievements</p>
                <p>
                  {data?.otherActivities
                    ?.map((activity) => activity)
                    .join(", ")}
                </p>
              </div>
            </div>
          </div>
        </>
      ) : (
        ""
      )}
    </div>
  );
};

export default UserResume;
